<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="success">Create New Cart</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h2>Create a New Cart</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-select
            class="ma-0"
            v-model="paymentType"
            :items="paymentTypeList"
            menu-props="auto"
            label="Select Payment Type"
            prepend-icon="map"
            single-line
            v-on:change="changeSelectedItem"
          ></v-select>
          <v-text-field
            v-model="email"
            label="Email"
            prepend-icon="email"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn @click="submit" class="success mx-0 mt-3" :loading="loading"
            >Create Empty Cart</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";
import { store } from "../store.js";

export default {
  data() {
    return {
      paymentType: "",
      email: "",
      loading: false,
      dialog: false,
      paymentTypeList: ["paypal", "invoice"]
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      let newCartId;
      this.$log.debug("Try to create cartId")
      newCartId = await cartApi.getCartId();
      this.$toast("Created new cartId " + newCartId.cartId);
      await cartApi.postCreatePaymentNoNotification(newCartId.cartId, this.email, this.paymentType);
      this.$toast("Created payment for " + newCartId.cartId);
      store.storeCartId(newCartId.cartId);
      this.loading = false;
      this.dialog = false;
    },
    changeSelectedItem() {
      this.$log.debug("Set payment type to: " + this.paymentType)
    }
  }
};
</script>
